import React, { Component } from "react";
import httpService from "../../services/httpService";
import config from "../../config.json";

class CovidPotvrzeni extends Component {
  state = {};

  componentDidMount = () => {
    this.nahrajPotvrzeni();
  };

  nahrajPotvrzeni = async () => {
    const potvrzeni = await httpService.post(
      config.apiEndpoint + "covid/potvrzeni.php"
    );
    this.setState({ loaded: true, potvrzeni: potvrzeni.data });
  };

  render() {
    const { loaded, potvrzeni } = this.state;
    return (
      <React.Fragment>
        {loaded &&
          (potvrzeni.potvrzeniZamestnani === "1" || potvrzeni.priselCas) && (
            <div className="row">
              <div className="col-12">
                <h2>Potvrzení zaměstnavatele</h2>
              </div>
              {potvrzeni.potvrzeniZamestnani === "1" && (
                <div className="col-md-6 pt-3 pb-3">
                  <p>Potvrzujeme, že:</p>
                  <p className="text-center">
                    <strong>{potvrzeni.jmeno}</strong>
                    <br />
                    narozen(a) {potvrzeni.datumNarozeni}
                  </p>
                  je zaměstnancem společnosti
                  <br />
                  <strong>{potvrzeni.nazevSpolecnosti}</strong>
                  <br />
                  (IČ: {potvrzeni.ic}, {potvrzeni.ulice}, {potvrzeni.psc}{" "}
                  {potvrzeni.mesto})
                </div>
              )}
              {potvrzeni.priselCas && (
                <div className="col-md-6 pt-3 pb-3">
                  <p>
                    Potvrzujeme, že {potvrzeni.jmeno} narozen{" "}
                    {potvrzeni.datumNarozeni} byl naposled testován antigenním
                    testem{" "}
                    <span style={{ whiteSpace: "nowrap" }}>
                      {potvrzeni.priselCas}
                    </span>{" "}
                    s výsledkem{" "}
                    <strong>
                      {potvrzeni.pozitivniVysledekCas
                        ? "POZITIVNÍ"
                        : "NEGATIVNÍ"}
                    </strong>
                  </p>
                </div>
              )}
              <div className="col-12">
                <p>
                  <strong>Kontakt pro ověření údajů:</strong>{" "}
                  {potvrzeni.telefonOvereni}
                </p>
              </div>
            </div>
          )}
        <hr />
        <div className="text-center">
          <a href="#/covid" className="btn btn-primary">
            Objednat se na test
          </a>
          {potvrzeni &&
          potvrzeni.rezervace &&
          potvrzeni.rezervace.length > 0 ? (
            <div className="mt-3">
              <h4>Přihlášené termíny</h4>
              <ul>
                {potvrzeni.rezervace.map((r) => (
                  <li key={r.rezervace_id}>
                    {r.casRezervace}: {r.nazev}
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <div className="alert alert-danger mt-3">
              Aktuálně nejsi přihlášen na další test!
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default CovidPotvrzeni;
